import { Input } from "antd";
import { type ChangeEvent, useEffect, useState } from "react";

type Props = {
  isEditMode: boolean;
  defaultValue: string;
  onSave: (value: string) => Promise<void>;
  disabled: boolean;
};

const StringEditableColumn = ({ isEditMode, defaultValue, onSave, disabled }: Props) => {
  const [loading, setLoading] = useState(false);

  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    setValue(defaultValue);
  }, [defaultValue]);

  const handleSave = async () => {
    setLoading(true);
    try {
      await onSave(value ? value.toString() : "");
    } finally {
      setLoading(false);
    }
  };

  if (isEditMode) {
    return (
      <Input
        onBlur={handleSave}
        disabled={loading || disabled}
        style={{ width: "100%" }}
        onPressEnter={handleSave}
        defaultValue={defaultValue}
        value={value ?? ""}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const inputValue = e.currentTarget.value;
          setValue(inputValue);
        }}
      />
    );
  }

  return defaultValue;
};

export default StringEditableColumn;
